import { createFeature, createReducer, on } from '@ngrx/store'
import { PlotAxis, PlotDataState } from './plot-data.state'
import { plotDataActions } from './plot-data.actions'
import { caseActions } from '../case/case.actions'

const createInitialState = (): PlotDataState => ({
    markerX: null,
    markerY: null,
    markerColor: null,
    isLoadingPlotData: false,
    pointSize: 10,
    pointOpacity: 10,
    lassoType: 'freeform',
})

export const plotDataFeature = createFeature({
    name: 'plotData',
    reducer: createReducer<PlotDataState>(
        createInitialState(),
        on(plotDataActions.loadDataForAxis, (state, action): PlotDataState => {
            return {
                ...state,
                isLoadingPlotData: true,
                markerX: action.axis === PlotAxis.X ? action.marker : state.markerX,
                markerY: action.axis === PlotAxis.Y ? action.marker : state.markerY,
                markerColor: action.axis === PlotAxis.COLOR ? action.marker : state.markerColor,
            }
        }),
        on(
            plotDataActions.loadDataBothAxes,
            (state, { markerXAxis, markerYAxis }): PlotDataState => {
                return {
                    ...state,
                    isLoadingPlotData: true,
                    markerX: markerXAxis,
                    markerY: markerYAxis,
                    markerColor: null,
                }
            }
        ),
        on(plotDataActions.plotDrawn, (state): PlotDataState => {
            return { ...state, isLoadingPlotData: false }
        }),
        on(plotDataActions.setPointSize, (state, { size }): PlotDataState => {
            return { ...state, pointSize: size }
        }),
        on(plotDataActions.setPointOpacity, (state, { opacity }): PlotDataState => {
            return { ...state, pointOpacity: opacity }
        }),
        on(plotDataActions.setLassoType, (state, { lassoType }): PlotDataState => {
            return { ...state, lassoType: lassoType }
        }),
        // TODO [ARIADNE-303]: should this be the same that triggers the loading of data?
        on(caseActions.loadCase, (): PlotDataState => createInitialState())
    ),
})

export const { reducer } = plotDataFeature
